import firebase from "firebase/compat";
import "firebase/auth"
import "firebase/firestore"


const app = firebase.initializeApp({
    // apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    // authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    // projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    // appId: process.env.REACT_APP_FIREBASE_APP_ID
    apiKey: "AIzaSyAnmjEU4lRyPBNx_EjZ3btF3A9zVON38tI",
    authDomain: "tourist-badges-web.firebaseapp.com",
    projectId: "tourist-badges-web",
    storageBucket: "tourist-badges-web.appspot.com",
    messagingSenderId: "745840591938",
    appId: "1:745840591938:web:083b0d9e0159f0a19999db"

})

export const auth = app.auth()
export default app